import { cropResizeSrc } from "components/shared/BlossomImage/BlossomImage";

export const optimizeHeroImageUrl = (imageUrl: string, isMobile?: boolean): string => {
  return isMobile
    ? cropResizeSrc(imageUrl, { width: 360, height: 224 }, "low")
    : cropResizeSrc(imageUrl, { width: 1040, height: 580 }, "high");
};

export const optimizeHotwireHeroImageUrl = (imageUrl: string, isMobile?: boolean): string => {
  return isMobile
    ? cropResizeSrc(imageUrl, { width: 575, height: 431 }, "medium")
    : cropResizeSrc(imageUrl, { width: 1176, height: 504 }, "medium");
};
